
import { musicStore } from '@/store';
import { AlbumEntry, MusicStoreState } from '@/store/MusicStore';
import { computed, reactive, toRefs, toRaw } from 'vue';
import AlbumCard from '@/components/AlbumCard.vue';
import AlbumListing from '@/components/AlbumListing.vue';

export default {
  setup() {
    let music: MusicStoreState;
    return {
      music: (music = musicStore.getState()),
      ...useAlbumSelection(),
      someAlbums: computed(() => Object.values(music.albums).slice(0, 5))
    };
  },
  components: {
    AlbumCard,
    AlbumListing
  }
};

function useAlbumSelection() {
  const state = reactive({
    currentAlbum: null as AlbumEntry
  });

  function selectAlbum(album: AlbumEntry): void {
    state.currentAlbum = album;
  }

  function isCurrentAlbum(album: AlbumEntry): boolean {
    return toRaw(state.currentAlbum) === toRaw(album);
  }

  return {
    ...toRefs(state),
    selectAlbum,
    isCurrentAlbum
  };
}
